export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120')
];

export const server_loads = [];

export const dictionary = {
		"/": [25],
		"/(app)/(login)/auth": [100,[2,23]],
		"/(app)/(other)/change-organization": [108,[2]],
		"/(app)/(login)/cred-login": [101,[2,23]],
		"/(app)/(authorised)/(provider)/credentialing-agent": [31,[2,7]],
		"/(app)/(authorised)/(provider)/credentialing-agent/[sessionId]": [32,[2,7]],
		"/(app)/(authorised)/(provider)/cvo-requests": [33,[2,7,9]],
		"/(app)/(authorised)/(provider)/cvo-requests/[path]": [34,[2,7,9]],
		"/(app)/(authorised)/(provider)/discover/license-verification": [35,[2,7]],
		"/(app)/(authorised)/(provider)/discover/provider-profile": [36,[2,7]],
		"/(app)/(authorised)/(provider)/discover/provider-profile/[id]": [37,[2,7]],
		"/(app)/(authorised)/(provider)/discover/search": [38,[2,7]],
		"/(app)/(authorised)/(facility)/facility/cvo-requests": [28,[2,3,6]],
		"/(app)/(authorised)/(facility)/facility/cvo-requests/[path]": [29,[2,3,6]],
		"/(app)/(authorised)/(facility)/facility/[facilityId=uuid]/(parent)": [26,[2,3,4,5]],
		"/(app)/(authorised)/(facility)/facility/[facilityId=uuid]/(parent)/[path]/[...rest]": [27,[2,3,4,5]],
		"/(app)/(login)/forgot-password": [102,[2,23]],
		"/(app)/(authorised)/(provider)/groups": [43,[2,7]],
		"/(app)/(authorised)/(provider)/group/[groupId=uuid]": [39,[2,7]],
		"/(app)/(authorised)/(provider)/group/[groupId=uuid]/detail/overview": [40,[2,7,10,11]],
		"/(app)/(authorised)/(provider)/group/[groupId=uuid]/detail/overview/[tab]": [41,[2,7,10,11]],
		"/(app)/(authorised)/(provider)/group/[groupId=uuid]/detail/payer/[id]": [42,[2,7,10]],
		"/(app)/(login)/login": [103,[2,24]],
		"/(app)/(login)/login/callback": [104,[2,24]],
		"/(other)/maintenance": [116],
		"/(app)/(authorised)/(provider)/my-network": [44,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/cvo-requests": [45,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/cvo-requests/assigned": [46,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/cvo-requests/cancellation-request": [47,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/issues": [54,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/issues/failed-verifications": [55,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/issues/failed-verifications/[tab=failedVerificationTab]": [56,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/issues/monitoring-alerts": [57,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/issues/npdb": [58,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/issues/sanctions": [59,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/monitoring": [60,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/monitoring/dashboard": [61,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/monitoring/providers": [62,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review": [63,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/board": [64,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/needs-review/caqh": [48,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/needs-review/caqh/import": [49,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/needs-review/caqh/merge": [50,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/certificate": [65,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/needs-review/cvo": [51,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/dea": [66,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/license": [67,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/medicaid": [68,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/npdb": [69,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/npi": [70,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/profile": [71,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/profile/[tab=profileImportListTab]": [72,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/needs-review/sanctions": [73,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/needsReview/[...any]": [52,[2,7,12,13]],
		"/(app)/(authorised)/(provider)/my-network/provider-license": [74,[2,7,12]],
		"/(app)/(authorised)/(provider)/my-network/(backward-routes)/providerLicense/[...any]": [53,[2,7,12,14]],
		"/(app)/(authorised)/(provider)/my-network/providers": [75,[2,7,12]],
		"/(app)/(login)/new-password": [105,[2,23]],
		"/(other)/not-support": [117],
		"/(app)/(other)/org-picker": [109,[2]],
		"/(app)/(other)/print/[providerId=uuid]/[entity]/[id]": [111,[2]],
		"/(app)/(other)/print/[entityType]/[entityId=uuid]/[entity]/[id]": [110,[2]],
		"/(app)/(authorised)/(provider)/(backward-routes)/provider-detail/[...any]": [30,[2,7,8]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]": [76,[2,7,15]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/ama-merge": [78,[2,16]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/ama-merge/[recordId]": [79,[2,16]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/ama-merge/[recordId]/add": [80,[2,16]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/ama-merge/[recordId]/review": [81,[2,16]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/caqh-merge": [82,[2,17]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/caqh-merge/[recordId]": [83,[2,17]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/caqh-merge/[recordId]/add": [84,[2,17]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/caqh-merge/[recordId]/resolve": [85,[2,17]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/caqh-merge/[recordId]/review": [86,[2,17]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/enrollment": [87,[2,7,15,18]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/enrollment/[tab]": [88,[2,7,15,18]],
		"/(app)/(authorised)/(provider)/provider/[provider=uuid]/[...tab]": [77,[2,7,15]],
		"/(other)/report-template": [118],
		"/(other)/report-template/[template]": [119],
		"/(app)/(login)/reset-password": [106,[2,23]],
		"/(app)/(other)/review/alert/[id]": [114,[2]],
		"/(app)/(other)/review/[providerId=uuid]/[entity]/[id]": [113,[2]],
		"/(app)/(other)/review/[entityType]/[entityId=uuid]/[entity]/[id]": [112,[2]],
		"/(app)/(other)/select-providers/[entityId]": [115,[2]],
		"/(app)/(authorised)/settings": [90,[2,19]],
		"/(app)/(authorised)/settings/account": [91,[2,19,20]],
		"/(app)/(authorised)/settings/account/[tab]": [92,[2,19,20]],
		"/(app)/(authorised)/settings/audit-logs": [93,[2,19]],
		"/(app)/(authorised)/settings/authentication": [94,[2,19,21]],
		"/(app)/(authorised)/settings/authentication/[tab]": [95,[2,19,21]],
		"/(app)/(authorised)/settings/coverage": [96,[2,19,22]],
		"/(app)/(authorised)/settings/coverage/[tab]": [97,[2,19,22]],
		"/(app)/(authorised)/settings/feature-preference": [98,[2,19]],
		"/(app)/(authorised)/settings/sources": [99,[2,19]],
		"/sso/admin": [120],
		"/(app)/(login)/temp-token-login": [107,[2,23]],
		"/(app)/(authorised)/(provider)/verifiable-ai": [89,[2,7]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';